import { useRest } from "../useRest";
import { buildKey } from "../utils/buildKey";
import { buildPrefetch } from "../utils/buildPrefetch";
import { routeTo } from "../utils/routeTo";
import { defaultOptions } from "./defaultOptions";

// Endpoints
const routes = {
  specialties: () => routeTo("codex", "specialties"),
  specialty: (id) => routeTo("codex", "specialties", id),
};

// Cache Keys
const keys = {
  specialties: () => buildKey("codex", "specialties"),
  specialty: (id) => buildKey("codex", "specialties", id),
};

// Prefetches
const prefetch = (queryClient) => ({
  list: (options) =>
    buildPrefetch({
      queryClient,
      url: routes.specialties(),
      key: keys.specialties(),
      options: {
        ...defaultOptions,
        ...options,
      },
    }),
  fetch: (id, options) =>
    buildPrefetch({
      queryClient,
      url: routes.specialty(id),
      key: keys.specialty(id),
      options: {
        ...defaultOptions,
        ...options,
      },
    }),
});

// Resource Actions
const actions = {
  list: (options) =>
    useRest.fetch({
      url: routes.specialties(),
      key: keys.specialties(),
      options: {
        ...defaultOptions,
        ...options,
      },
    }),
  fetch: (id, options) =>
    useRest.fetch({
      url: routes.specialty(id),
      key: keys.specialty(id),
      options: {
        ...defaultOptions,
        ...options,
      },
    }),
};

/**
 * Assemble export
 */
export const useCodexSpecialty = {
  routes,
  keys,
  prefetch,
  ...actions,
};
